import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import { useHistory } from 'react-router-dom';

import Button from 'src/components/atoms/Button';
import InputPassword from 'src/components/molecules/InputPassword';
import Logo from 'src/logos/Logo';
import { clearState, resetPassword } from 'src/slices/auth';
import css from './Login.module.scss';
import { handleStatus } from 'src/slices/utils';
import { setEmail } from 'src/slices/signup';

export default function ResetPass() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { status } = useSelector((state) => state.auth);

  const params = useParams();

  const [credentials, setCredentials] = useState({
    password: '',
    confirmedPassword: '',
  });

  // Input Validation
  const resetPasswordValidator = (userCredentials) => {
    if (!userCredentials.password) {
      toast.warning(`"Password" is a required field`);
      return null;
    } else if (
      !userCredentials.confirmedPassword ||
      userCredentials.password != userCredentials.confirmedPassword
    ) {
      toast.warning(`"Password" and "Confirmed Password" must match"`);
      return null;
    }

    if (userCredentials.password.length < 8) {
      toast.warning('Password must be at least 8 characters long');
      return null;
    }
    return userCredentials;
  };

  const handleResetPassword = () => {
    if (resetPasswordValidator(credentials)) {
      dispatch(
        resetPassword({
          ...params,
          credentials,
        }),
      );
    }
  };

  useEffect(() => {
    handleStatus(status.resetPassword, () => dispatch(clearState(status.resetPassword)), {
      isSuccess: {
        callback: () => {
          dispatch(setEmail(params.email));
          if (location.pathname.includes('confirmation')) {
            navigate('/set-pin');
          } else {
            navigate('/login');
          }
        },
      },
    });
  }, [status.resetPassword]);

  return (
    <>
      <div className={css.page}>
        <Logo width="260px" />
        <form className={css.box}>
          <div className={css.component}>
            <h3 className={css.title}>Reset Password</h3>
            <p>Please choose a new password for your account</p>
            <div className={css.inputs}>
              <InputPassword
                label="New Password"
                onChange={(e) => {
                  setCredentials({
                    ...credentials,
                    password: e.target.value,
                  });
                }}
                showForgot={false}
                onKeyPress={(e) => (e.key == 'Enter' ? handleResetPassword() : null)}
              />
              <InputPassword
                label="Confirm New Password"
                showForgot={false}
                onChange={(e) => {
                  setCredentials({
                    ...credentials,
                    confirmedPassword: e.target.value,
                  });
                }}
                onKeyPress={(e) => (e.key == 'Enter' ? handleResetPassword() : null)}
              />
            </div>
            <div className={css.buttons}>
              <Button
                action={handleResetPassword}
                label={
                  location.pathname.includes('confirmation')
                    ? 'Continue to Set Pin'
                    : 'Set Password'
                }
                color="white"
                // href='us'
              />
            </div>
          </div>
        </form>
      </div>
      {/* <ToastContainer /> */}
    </>
  );
}
